import React, { useEffect, useRef } from 'react';
import { useT } from 'talkr';
import s from './index.module.scss';
import classNames from 'classnames';
import steps from '../../../survey/steps';
import cardsImg from './img/newRes_cards.png';

function NewYearStartScreen() {
	const { T } = useT();
	const button = useRef();

	useEffect(() => {
		steps.setStepStatus({
			stepName: 'new_year_start_screen',
			stepStatus: true
		});
	}, []);

	function goForward() {
		steps.navigate.forward({
			preventAction: 500
		});
	}

	return (
		<div className={s.newYearStartScreen_wrapper}>
			<div className={classNames(s.newYearStartScreen_title_wrapper)}>
				<div className={classNames(s.newYearStartScreen_title)}>New year</div>
				<div className={classNames(s.newYearStartScreen_title, s.newYearStartScreen_title_bg)}>New life</div>
			</div>
			<img className={s.newYearStartScreen_cards} src={cardsImg} alt='photos'></img>
			<div className={classNames(s.newYearStartScreen_title)}></div>
			<div className={s.newYearStartScreen_button}>
				<button
					onClick={goForward}
					className={s.button}
					ref={button}
					type="button">{T('xmasStartScreen_button')}</button>
			</div>
		</div>
	);
}

export default NewYearStartScreen;
